var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafficpakIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#2D71D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.508 17.167H7.667v1.666h5.841v2.5L16.833 18l-3.325-3.333v2.5zm4.984-.834v-2.5h5.841v-1.666h-5.841v-2.5L15.167 13l3.325 3.333z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iNiIgZmlsbD0iIzJENzFEMSIvPgo8cGF0aCBkPSJNMTMuNTA4NCAxNy4xNjY3SDcuNjY2NzVWMTguODMzNEgxMy41MDg0VjIxLjMzMzRMMTYuODMzNCAxOC4wMDAxTDEzLjUwODQgMTQuNjY2N1YxNy4xNjY3Wk0xOC40OTE3IDE2LjMzMzRWMTMuODMzNEgyNC4zMzM0VjEyLjE2NjdIMTguNDkxN1Y5LjY2Njc1TDE1LjE2NjcgMTMuMDAwMUwxOC40OTE3IDE2LjMzMzRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgTrafficpakIcon as ReactComponent };